import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export function MustMatch(
  password: string,
  confirmPassword: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const passwordControl = control.get(password);
    const confirmPasswordControl = control.get(confirmPassword);

    if (!passwordControl || !confirmPasswordControl) {
      return null;
    }

    if (confirmPasswordControl.value !== passwordControl.value) {
      confirmPasswordControl.setErrors({
        ...confirmPasswordControl.errors,
        mustmatch: true,
      });

      return {
        mustmatch: true,
      };
    }

    // Remove only our custom error
    if (confirmPasswordControl.hasError('mustmatch')) {
      const errors = { ...confirmPasswordControl.errors };

      delete errors['mustmatch'];

      confirmPasswordControl.setErrors(
        Object.keys(errors).length ? errors : null
      );
    }

    return null;
  };
}